import { render, staticRenderFns } from "./ImprintPage.vue?vue&type=template&id=a41285e0&scoped=true"
import script from "./ImprintPage.vue?vue&type=script&lang=ts"
export * from "./ImprintPage.vue?vue&type=script&lang=ts"
import style0 from "./ImprintPage.vue?vue&type=style&index=0&id=a41285e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a41285e0",
  null
  
)

export default component.exports